import { PureComponent } from 'react';
import Utils from 'app/common/util/Utils';

interface SettingsContentPanelProps<Settings> {
    settings: Settings;
    onChange?: (settings: Settings) => void;
    onClose?: () => void;
}

export abstract class SettingsContentPanel<Settings> extends PureComponent<
    SettingsContentPanelProps<Readonly<Settings>>,
    Settings
> {
    private appliedSettings: Settings; // Used to reset settings to last valid settings when user clicks on cancel button
    constructor(props) {
        super(props);
        this.state = this.props.settings;
        this.appliedSettings = { ...this.state };
    }

    componentDidUpdate(prevProps: SettingsContentPanelProps<Readonly<Settings>>) {
        if (Utils.isNotShallowEquals(prevProps.settings, this.props.settings)) {
            this.appliedSettings = { ...this.props.settings };
            this.setState(this.appliedSettings);
        }
    }

    handleApply = () => {
        this.props.onChange?.(this.state);
        this.appliedSettings = { ...this.state };
    };
    handleClose = () => {
        this.props.onClose?.();
        this.setState(this.appliedSettings);
    };
}
